import React from 'react'
import { useTranslation } from 'i18n'
import { Difference } from './Difference'
import differencesCategoryMapper from 'steps/spot-the-diff/utils/differenceCategoryMapper'

const DifferenceCounter = ({ state }) => {
  const { t } = useTranslation('spotTheDiff')
  const orderedDifferences = state.differences.sort(
    (a, b) => b.userFound - a.userFound,
  )

  return (
    <div className="differences">
      <div className="differences__label">{t('differencesLabel')}</div>
      <div className="differences__checkboxes">
        {orderedDifferences.map(({ id, notFoundInTime, userFound }) => (
          <Difference
            key={id}
            type={differencesCategoryMapper({
              notFoundInTime,
              userFound,
            })}
          />
        ))}
      </div>
    </div>
  )
}

export default DifferenceCounter
